import { Component, OnInit } from "@angular/core";
import { ContenutoGenerico } from "../model/contenuto-generico";
import { ContenutoGenericoService } from "../service/contenuto-generico.service";
import { Search } from "../common/search";
import { AllegatoService } from "../service/allegato.service";
import { ActivatedRoute } from "@angular/router";
import { Allegato } from "../model/allegato";
import { MultilinguaService } from "../service/multilingua.service";
import { MenuService } from "../service/menu.service";
import { Multilingua } from "../model/multilingua";
import { Location } from "@angular/common";
import { SeoService } from "../service/seo.service";
import { DOCS_REPLACE } from "../constants/constants";

@Component({
  selector: "app-societa-trasparente",
  templateUrl: "./societa-trasparente.component.html",
})
export class SocietaTrasparenteComponent implements OnInit {
  public component: string = null;
  public element: ContenutoGenerico;
  public allegato: Allegato;
  public loading = true;
  public lingua: string;

  constructor(
    private contenutoService: ContenutoGenericoService,
    private allegatoService: AllegatoService,
    private multilingueService: MultilinguaService,
    private location: Location,
    private menuService: MenuService,
    private seoService: SeoService,
    public route: ActivatedRoute
  ) {
    this.element = new ContenutoGenerico();
  }

  ngOnInit() {
    this.route.url.subscribe(() => {
      const url = this.location.path().split("/");
      this.component = url.pop();
      this.contenutoService
        .find(this.component)
        .subscribe((societaTrasparente) => {
          this.element = societaTrasparente;
          this.lingua = this.element.lang;
          this.getOtherLangs();
          // this.seoService.addSeo(sostenibilita);
          this.allegatoService
            .find(societaTrasparente.immagine)
            .subscribe((allegato) => {
              if (allegato) {
                this.allegato = allegato;
                this.allegato.path = DOCS_REPLACE(allegato.uuid);
                this.seoService.setImage(this.allegato.path);
              }
              this.loading = false;
            });
        });
    });
  }

  getOtherLangs() {
    this.multilingueService.search = new Search<Multilingua>(Multilingua);
    if (this.lingua === "IT") {
      this.multilingueService.search._.it = this.element.uuid;
    } else if (this.lingua === "EN") {
      this.multilingueService.search._.eng = this.element.uuid;
    }
    this.multilingueService.getList().subscribe((link) => {
      // console.log('link trovato: ' + link);
      const lingue = [];
      if (link.length > 0) {
        if (this.lingua === "EN" && link[0].it) {
          lingue.push("IT");
        }
        if (this.lingua === "IT" && link[0].eng) {
          lingue.push("EN");
        }
      }
      this.menuService.add(lingue);
    });
  }
}
